

import { useComponentRoute, Ipage } from "@/hooks/useComponentRoute"
import { reactive, markRaw, defineAsyncComponent } from 'vue'
// 页面路由表
const page = reactive<Ipage[]>([
    {
        name: 'loginList',
        component: markRaw(defineAsyncComponent(() => import('./pages/LoginList.vue'))),
        params: {}
    },
    {
        name: 'emailLogin',
        component: markRaw(defineAsyncComponent(() => import('./pages/EmailLogin.vue'))),
        params: {}
    },
])
const selfRouter = useComponentRoute(page)
export default selfRouter

